import React from 'react';
import { STATIC_FRAME_ID } from '../../constants';
import styles from './static-preview.module.scss';
import config from '../../config';

export function StaticPreview({ url, className }: { url: string; className?: string }) {
	return (
		<>
			{config.feature_markStaticSite && (
				<div className={styles.staticSiteMarker}>static</div>
			)}
			<iframe
				src={url}
				id={STATIC_FRAME_ID}
				name={STATIC_FRAME_ID}
				height="100%"
				width="100%"
				sandbox="allow-forms allow-scripts allow-same-origin"
				className={className}
				style={{ background: 'white' }}
			/>
		</>
	);
}
